import React from "react";
import { Modal } from "antd";
import { CompletionModalProps } from "./types";
import { ButtonContainer, ImageContainer } from "./styles";
import Typography from "../../../../../../../../components/Typography";
import Button from "../../../../../../../../components/Button";
import ThemeColors from "../../../../../../../../themes/colors";
import { Column } from "../../../../../../../../themes/globalStyle";

const CompletionModal: React.FC<CompletionModalProps> = ({
  modalOpen,
  setCompletionModal,
  onComplete,
  onAddNew,
}): JSX.Element => {
  return (
    <Modal
      destroyOnClose
      title={null}
      width={680}
      open={modalOpen}
      onCancel={() => setCompletionModal(false)}
      footer={null}
    >
      <Column
        style={{ alignItems: "center", height: "12rem" }}
      >
        <ImageContainer>
          <Typography
            text="✅"
            size="halfExtraHuge"
            color="Black500"
            weight={600}
          />
        </ImageContainer>
        <Typography
          text="Objetivo Criado com Sucesso!"
          size="huge"
          color="Black500"
          weight={600}
        />
        <Typography
          text="Você deseja adicionar mais algum objetivo ou podemos concluir e gerar o calendário estratégico?"
          size="medium"
          color="Black200"
          weight={400}
          textAlign="center"
        />
      </Column>
      <ButtonContainer>
        <Button
          size="middle"
          borderRadius="0.5rem"
          style={{ width: "fit-content" }}
          backgroundColor={ThemeColors.Black500}
          onClick={onComplete}
        >
          <Typography
            text="Concluir criação de objetivos"
            size="medium"
            color="Bg300"
            weight={400}
          />
        </Button>
        <Button
          size="middle"
          borderRadius="0.5rem"
          style={{ width: "fit-content" }}
          backgroundColor={ThemeColors.Black500}
          onClick={onAddNew}
        >
          <Typography
            text="Adicionar novo objetivo"
            size="medium"
            color="Bg300"
            weight={400}
          />
        </Button>
      </ButtonContainer>
    </Modal>
  );
};

export default CompletionModal;
